import { render, staticRenderFns } from "./agregarDependencia.vue?vue&type=template&id=0e827b3e"
import script from "./agregarDependencia.vue?vue&type=script&lang=js"
export * from "./agregarDependencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports